import * as React from "react";
function SvgIcRefresh(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M7 2.917a4.083 4.083 0 103.955 5.104l1.13.291A5.252 5.252 0 011.75 7a5.25 5.25 0 019.333-3.3V2.333h1.167v3.5h-3.5V4.667h1.602A4.079 4.079 0 007 2.917z" fill="currentColor" /></svg>;
}
export default SvgIcRefresh;